export default __webpack_public_path__ + "static/media/placeholder_book.bc9be9f6.svg";